import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace AddressBookApi {
    /**
    * 列表
    */
    export var GetList = (query: any): Promise<any> => {
        return Get(`/msls/AddressBook/GetList?${qs.stringify(query)}`, {});
    };
    /**
    * 新增
    */
    export var AddOrEdit = (body: any): Promise<any> => {
        return Post(`/msls/AddressBook/AddOrEdit`, body);
    };
    /**
    * 详情
    */
    export var GetDetail = (id): Promise<any> => {
        return Get(`/msls/AddressBook/GetDetail/${id}`, {});
    };

    /**
    * 地址识别
    */
    export var AddressDistinguish = (query: any): Promise<any> => {
        return Get(`/msls/AddressBook/AddressDistinguish`, { text: query });
    };

    /**
    * 根据地址类型获取所有地址簿数据下拉
    */
    export var GetAddressBookList = (query: any): Promise<any> => {
        return Get(`/msls/AddressBook/GetAddressBookList?${qs.stringify(query)}`, {});
    };


    /**
     * 删除
     */
    export var DoDelete = (id: any): Promise<any> => {
        return Put(`/msls/AddressBook/Delete/${id}`, {});
    };
    /**
     * 获取发货方
     */
    export var GetDropDownList = ():Promise<any> =>{
        return Get(`msls/Shipper/GetDropDownList`,{});
    }
    /**获取省 */
    export var GetProvince = ():Promise<any> =>{
        return Get(`/msls/AreaApi/GetProvince`,{})
    }
    /**获取市 */
    export var GetCity = (provincecode):Promise<any> =>{
        return Get(`/msls/AreaApi/GetCity/${provincecode}`,{})
    } 
    /**获取区 */
    export var GetCountry = (citycode):Promise<any> =>{
        return Get(`/msls/AreaApi/GetCounty/${citycode}`,{})
    } 
    /**获取列表 */
    export var GetZoneList = (query: any): Promise<any> => {
        return Get(`/msls/AreaApi/GetZoneList?${qs.stringify(query)}`, {});
    };
    /**新增
     * */
    export var AddZone = (body: any): Promise<any> => {
        return Post(`/msls/AreaApi/AddZone`, body);
    };
    /**修改 */
    export var SaveZone = (id: any,body): Promise<any> => {
        return Put(`/msls/AreaApi/SaveZone/${id}`, body);
    };
    /**删除 */
    export var DeleteZone = (id: any): Promise<any> => {
        return Delete(`/msls/AreaApi/DeleteZone/${id}`, {});
    };
    /**详情 */
    export var GetZone = (id): Promise<any> => {
        return Get(`/msls/AreaApi/GetZone/${id}`, {});
    };
    /**获取地址簿列表 */
    export var GetAddressNameList = (query:any): Promise<any> => {
        return Get(`/msls/AddressBook/GetAddressNameList?${qs.stringify(query)}`, {});
    };
    /**获取省市区的树列表 */
    export var GetTreeList = (query:any): Promise<any> => {
        return Get(`/msls/AreaApi/GetTreeList?${qs.stringify(query)}`, {});
    };
}
